<template>
  <div :class="['py-30 px-30 br-12', bgSection]">
    <h3 class="fs-18 lh-24 mb-20" v-if='titleSection'>{{titleSection}}</h3>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SideBarSections',
  props: {
    bgSection: { type: String },
    titleSection: { type: String, default: null }
  }
}
</script>

<style scoped>

</style>
